import React, { useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { ratingSend } from "../../redux/modules/meeting";
import { Rating } from 'react-simple-star-rating'

const PopupRate = ({eventTypeId, close}) => {
    const dispatch = useDispatch();
    const [rating, setRating] = useState(0)
    const [value, setValue] = useState()
    
    const auth = useSelector(state => state.auth);
    const rateId = useSelector(state => state.meeting.rateId);

    const handleSubmit = (rate) => {
        
        if(rating && value) {
            dispatch(
                ratingSend({
                    cmd: 'orders-rate',
                    id: rateId,
                    comment: value,
                    rate: rating,
                    _debug_token: auth.token
                })
            )
        }
    }
    

    return (
        <div className="popup-meeting">
            <div className="popup-meeting__close" onClick={close}></div>
            <div className="popup-meeting__wrap">
                <div className="popup-meeting__title">Оценка {eventTypeId == 1 ? 'встречи' : 'брокер-тура'}</div>
                <div className="popup-meeting__text">Оцените, пожалуйста, работу менеджера по<br/>5-ти бальной шкале, где 5 максимальная оценка</div>
                <div className="popup-meeting__rating">
                    <Rating
                        emptyIcon={<img src="/img/star-empty.svg" className="icon" />}
                        fillIcon={<img src="/img/star-full.svg" className="icon" />}
                        onClick={(rate) => setRating(rate)}
                        transition={false}
                        allowTitleTag={false}
                    />
                </div>
                <div className="popup-meeting__textarea">
                    <textarea 
                        placeholder='Добавьте комментарий '
                        value={value} 
                        className="form__textarea"
                        onChange={(e) => setValue(e.target.value)}
                    />
                </div>

                <button className={rating && value ? "btn" : "btn btn_disable"} onClick={handleSubmit}>Сохранить</button>
            </div>
        </div>
    )
}

export default PopupRate